import { render, staticRenderFns } from "./ChannelProductListAssociationMultiView.vue?vue&type=template&id=a62d1966&scoped=true&"
import script from "./ChannelProductListAssociationMultiView.vue?vue&type=script&lang=js&"
export * from "./ChannelProductListAssociationMultiView.vue?vue&type=script&lang=js&"
import style0 from "./ChannelProductListAssociationMultiView.vue?vue&type=style&index=0&id=a62d1966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62d1966",
  null
  
)

export default component.exports